module.exports = __webpack_public_path__ + "static/media/delete-icon.71b3db92.svg";